<div (click)="abrirModal()" class="tarjeta" style="cursor:pointer;">
  <div class="tarjeta_image">
    <!-- Mostrar imagen normal si no hay videoId -->
    <img *ngIf="!videoId" [src]="imagen" alt="" />

    <!-- Mostrar miniatura de video si hay videoId -->
    <img
      *ngIf="videoId"
      [src]="'https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg'"
      alt="Video thumbnail"
    />

    <!-- Icono de play si es video -->
    <div *ngIf="videoId" class="play_icon_overlay">
      <img src="assets/icons/icono-play.svg" alt="play-icon" />
    </div>
  </div>

  <div class="tarjeta_text">
    <div class="tarjeta_fondo">
      <div class="tarjeta_contenido">
        <div class="title_text">{{ titulo }}</div>
        <div class="text">{{ texto }}</div>
        <div class="ver_mas">
          <div></div>
          <div class="ver_mas_content">
            <div class="ver_mas_circle"></div>
            <p class="ver_mas_text">Ver +</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div *ngIf="showModal" class="modal_overlay" (click)="cerrarModal()">
  <div class="modal_contenido" (click)="$event.stopPropagation()">
    <button class="modal_cerrar" (click)="cerrarModal()">
      <i
        style="
          font-style: normal;
          transform: scaleX(1.3);
          display: inline-block;
        "
        class="fa-thin fa-x fa-lg"
      ></i>
    </button>

    <iframe
      *ngIf="videoId"
      width="560"
      height="315"
      [src]="videoUrl"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>

    <ng-container *ngIf="!videoId">
      <img [src]="imagen" alt="" />
      <div>
        <h2>{{ titulo }}</h2>
        <p>{{ texto }}</p>
      </div>
    </ng-container>
  </div>
</div>
